import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { excludeLoginLevel } from 'utils/routes/excludeLoginLevel';
import { allowSuperuserOnly } from 'utils/routes/allowSuperuserOnly';
import { filterQueryParametersAndReplace } from 'utils/url';
import { BetaFeatures } from 'apps/settings/consts';

export default [
  {
    path: 'getRawFoodSegregationOptions(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/delivery-preferences'),
    ],
  },
  {
    path: 'settings/delivery-preferences',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/delivery-preferences'),
    ],
  },
  {
    path: 'getMarketingOptions(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/marketing-communications'),
    ],
  },
  {
    path: 'settings/marketing-communications',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/marketing-communications'),
    ],
  },
  {
    path: 'editCalendarEvents(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/calendar-reminders'),
    ],
  },
  {
    path: 'settings/calendar-reminders',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/calendar-reminders'),
    ],
  },
  {
    path: 'getHealthifySettings(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN, BetaFeatures.HEALTHIFY]),
      filterQueryParametersAndReplace('/settings/calorie-saver'),
    ],
  },
  {
    path: 'settings/calorie-saver',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN, BetaFeatures.HEALTHIFY]),
      filterQueryParametersAndReplace('/settings/calorie-saver'),
    ],
  },
  {
    path: 'editSMSAlertSettings(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/delivery-sms-reminders'),
    ],
  },
  {
    path: 'settings/delivery-sms-reminders',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/delivery-sms-reminders'),
    ],
  },
  {
    path: 'facebookActions(.go)(.do)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/facebook-login'),
    ],
  },
  {
    path: 'settings/facebook-login',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/facebook-login'),
    ],
  },
  {
    path: 'settings/contact-details',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/contact-details'),
    ],
  },
  {
    path: 'editPersonalDetails(.go)(.do)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/contact-details'),
    ],
  },
  {
    path: 'paypalActions(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/paypal-login'),
    ],
  },
  {
    path: 'settings/paypal-login',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/paypal-login'),
    ],
  }, {
    path: 'editLoginDetails(.do)(.go)',
    onEnterHandlers: [
      excludeLoginLevel('SUPERUSER'),
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/login-password'),
    ],
  },
  {
    path: 'settings/login-password',
    onEnterHandlers: [
      excludeLoginLevel('SUPERUSER'),
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/login-password'),
    ],
  },
  {
    path: 'settings/address-book/:id/edit',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      (nextState) => {
        const { id } = nextState.location.params;
        return filterQueryParametersAndReplace(`/settings/address-book/${id}/edit`);
      },
    ],
  },
  {
    path: 'settings/address-book',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/address-book'),
    ],
  },
  {
    path: 'settings/address-book/add',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/address-book/add'),
    ],
  },
  {
    path: 'addressBook(.go)(.do)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/address-book'),
    ],
  },
  {
    path: 'settings/payment-details',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/payment-details'),
    ],
  },
  {
    path: 'getSavedDetails(.go)(.do)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/payment-details'),
    ],
  },
  {
    path: 'setupHPPSettings(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/add-payment-type'),
    ],
  },
  {
    path: 'settings',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings'),
    ],
  },
  {
    path: 'displaySettingsMenu(.go)(.do)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings'),
    ],
  },
  {
    path: 'editPreAuthSetting(.go)(.do)',
    onEnterHandlers: [
      allowSuperuserOnly,
      verifyRequiredBetaFeatures([BetaFeatures.ACCOUNT_SETTINGS_RAVEN]),
      filterQueryParametersAndReplace('/settings/checkout'),
    ],
  },
];
